export default "__VITE_ASSET__CBP90z58__"